import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';

export const getProgramAltImageText = (challenge: Challenge) =>
  challenge?.settings?.seo?.imageAlt;
